export const dashboardValues = [
    {
        value: 'codes-and-facilities',
        label: 'Codes and Facilities',
        tabs: [
            { label: 'SCAC', index: 0 },
            { label: 'SCAC Type', index: 1 },
            { label: 'Facility', index: 2 },
            { label: 'Facility Type', index: 3 },
            { label: 'Store', index: 4 },
            { label: 'Commodity Code', index: 5 },
            { label: ' Service Level', index: 6 },
            { label: 'Departments', index: 2 }


        ]
    },
    { value: 'vendors', label: 'Vendors' },
    {
        value: 'exceptions',
        label: 'Exceptions',
        tabs: [
            // { label: 'PO', index: 0, disabledForVendor: true },  // New property here
             { label: 'Store/Buyer', index: 0 },
             { label: 'PO', index: 1, disabledForVendor: true },
             { label: 'PO Search', index: 2, disabledForVendor: true }
        ] 
    },
    { value: 'routing-guides', label: 'Routing Guides' },
    { value: 'pre-ticket', label: 'Pre-Ticket' },
];
